export default function isFunction(value) {
    return typeof value === 'function';
}
